import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import mainPageService from "../../../services/main-page.service";
import { Grid } from "@material-ui/core";

const initialValues = {
    title: "",
    destinationURL: "",
    image: "",
    moreButton: []
};

const schema = Yup.object().shape({
    title: yupSchema.title,
    destinationURL: yupSchema.destinationURL,
    image: yupSchema.image,
    moreButton: yupSchema.moreButton,
});

const form = [
    {
        _type: "textField",
        name: "title",
        label: "عنوان",
        autoFocus: true,
    },
    {
        _type: "textField",
        name: "destinationURL",
        label: "آدرس مقصد",
    },
    {
        _type: "filePicker",
        name: "image",
        label: "عکس",
        isImage: true,
    },

    {
        _type: "array",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        _itemsWrapper: (props) => (
            <Grid item xs>
                <Grid container spacing={2} {...props} />
            </Grid>
        ),
        name: "moreButton",
        label: "دکمه های بیشتر",
        dense: true,
        minLength: 1,
        emptyValue: {
            title: '',
            href: '',
        },
        items: [
            {
                _type: "textField",
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                name: "title",
                label: "عنوان",
                autoFocus: true,
            },
            {
                _type: "textField",
                _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
                name: "href",
                label: "آدرس مقصد",
            }
        ],
    },
];

export default function FormModalContent({ close, data, type = "fullCard", name = "ردیف خانه", hasMoreButton = false }) {

    const errorHandler = useErrorHandler();

    const handleSubmit = async (model, { setSubmitting }) => {

        model.otherInfo = {
            moreButton: model.moreButton
        }
        let op;
        if (data?.id) {
            op = await mainPageService.editMainPage(data.id, { ...model, type });
        } else {
            op = await mainPageService.createMainPage({ ...model, type });
        }
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    return (
        <DialogFormBuilder
            {...{
                close,
                name: name,
                data,
                schema,
                initialValues,
                handleSubmit,
                form: form.filter(item => hasMoreButton || (!hasMoreButton && item.name !== "moreButton")),
            }}
        />
    );
}
